/* Servicio que hace la petición, Solo hace la llamada HTTP y devuelve la data. Nada de manejo de estado ni navegación. */
import api from "./api";

export const LoginApi = async (credentials) => {
  try {
    const { data } = await api.post("/login", credentials);
    return data; // { access_token, user }
  } catch (error) {
    throw error.response?.data?.message || "Error al iniciar sesión";
  }
};

